import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'wifi-cog',
  size: 24,
  node: [
    ['path', { d: 'm14.305 19.53.923-.382', key: '3m78fa' }],
    ['path', { d: 'm15.228 16.852-.923-.383', key: 'npixar' }],
    ['path', { d: 'm16.852 15.228-.383-.923', key: '5xggr7' }],
    ['path', { d: 'm16.852 20.772-.383.924', key: 'dpfhf9' }],
    ['path', { d: 'm19.148 15.228.383-.923', key: '1reyyz' }],
    ['path', { d: 'm19.53 21.696-.382-.924', key: '1goivc' }],
    ['path', { d: 'M2 8.82a15 15 0 0120 0', key: '1nil1f' }],
    ['path', { d: 'm20.772 16.852.924-.383', key: 'htqkph' }],
    ['path', { d: 'm20.772 19.148.924.383', key: '9w9pjp' }],
    ['path', { d: 'M5 12.859a10 10 0 0110.18-2.342', key: '1tqyl2' }],
    ['path', { d: 'M8.5 16.429a5 5 0 011.998-1.2', key: 'vrrh85' }],
    ['circle', { cx: '18', cy: '18', r: '3', key: '1xkwt0' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name WifiCog
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTQuMzA1IDE5LjUzLjkyMy0uMzgyIiAvPgogIDxwYXRoIGQ9Im0xNS4yMjggMTYuODUyLS45MjMtLjM4MyIgLz4KICA8cGF0aCBkPSJtMTYuODUyIDE1LjIyOC0uMzgzLS45MjMiIC8+CiAgPHBhdGggZD0ibTE2Ljg1MiAyMC43NzItLjM4My45MjQiIC8+CiAgPHBhdGggZD0ibTE5LjE0OCAxNS4yMjguMzgzLS45MjMiIC8+CiAgPHBhdGggZD0ibTE5LjUzIDIxLjY5Ni0uMzgyLS45MjQiIC8+CiAgPHBhdGggZD0iTTIgOC44MmExNSAxNSAwIDAxMjAgMCIgLz4KICA8cGF0aCBkPSJtMjAuNzcyIDE2Ljg1Mi45MjQtLjM4MyIgLz4KICA8cGF0aCBkPSJtMjAuNzcyIDE5LjE0OC45MjQuMzgzIiAvPgogIDxwYXRoIGQ9Ik01IDEyLjg1OWExMCAxMCAwIDAxMTAuMTgtMi4zNDIiIC8+CiAgPHBhdGggZD0iTTguNSAxNi40MjlhNSA1IDAgMDExLjk5OC0xLjIiIC8+CiAgPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/wifi-cog
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WifiCog = createLucideIcon(__iconData);

export default WifiCog;
